import React from 'react';
import { css } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Pagination, styled } from '@mui/material';
import { IGetResidentGasDetaSetsRes} from "@/types/api/bDevice/residentGasDataSets";
import { DataSetListItem } from './datasetListItem';
import { useTranslation } from 'react-i18next';

interface Props {
  datasets: IGetResidentGasDetaSetsRes[];
  addGraph: (start: string, end: string) => void;
  updateGraph: (start: string, end: string) => void;
  onClose: () => void;
}

const Container = css`
  width: 320px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Header = css`
  padding: 16px;
  flex-shrink: 0;
`;

const Title = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  font-size: 18px;
  flex-shrink: 0;
`;

const DatasetList = css`
  padding: 0 16px 16px;
  overflow-y: auto;
`;

const IconStyle = css`
  cursor: pointer;
`;

export const Dataset = React.memo(({ datasets, addGraph, updateGraph, onClose }: Props) => {
  const [page, setPage] = React.useState(1);
  const { t } = useTranslation();

  const handleChangePage = React.useCallback((e, value: number) => {
    setPage(value);
  }, []);

  const totalPages = Math.ceil(datasets.length / 10);

  const paginationDataset = React.useMemo(() => {
    if (datasets.length < 10) {
      return datasets;
    }
    if (page === 1) {
      return datasets.slice(0, 10);
    }
    return datasets.slice((page - 1) * 10, 10 * page);
  }, [page]);

  return (
    <div css={Container}>
      <div css={Header}>
        <div css={Title}>
          {t('dataset', 'データセット')}
          <CloseIcon css={IconStyle} onClick={onClose} />
        </div>
      </div>
      <div css={DatasetList}>
        {paginationDataset.map((dataset) => (
          <DataSetListItem
            key={dataset.startDateTime}
            dataset={dataset}
            addGraph={addGraph}
            updateGraph={updateGraph}
          />
        ))}
      </div>
      <Pagination
        sx={{ marginBottom: '8px', justifyContent: 'center' }}
        count={totalPages}
        page={page}
        onChange={handleChangePage}
      />
    </div>
  );
});
